import { Dispatch, SetStateAction } from "react";
import { omitBy, isNil } from "lodash";

import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { ITaskSchedule } from "../../shared/db";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_DELETE_TASK_SCHEDULE } from "../state";
import { getToken } from "./token_fetcher";
import { getTaskScheduleSchemaMap } from "../../model/schedule";

export const REQUEST_TASK_SCHEDULE_DELETE = "REQUEST_TASK_SCHEDULE_DELETE";
export const doREQUEST_TASK_SCHEDULE_DELETE = createDoRequestAction(REQUEST_TASK_SCHEDULE_DELETE);

export const requestTaskScheduleDeleteActionCreators = {
  doREQUEST_TASK_SCHEDULE_DELETE,
};

interface Payload {
  payload: {
    requestId: string;
    id: string;
    liveEditing: boolean;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestTaskScheduleDelete({ payload, setRequestResult }: Payload): SagaIterator {
  debug("saga*requestTaskScheduleDelete");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        id: v.string().uuid().required(),
        liveEditing: v.bool().default(false),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SCHEDULE_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const accessToken = yield call(getToken);

  const { id, liveEditing } = payload;

  const result = yield request({
    method: "post",
    url: `${API_URL}/v2/web/task-schedule-delete`,
    accessToken,
    data: { id, inplace: !liveEditing },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SCHEDULE_DELETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v2/web/task-schedule-delete",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doMETHOD_DELETE_TASK_SCHEDULE({ id }));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_SCHEDULE_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* taskScheduleDeleteSaga() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yield takeEvery(REQUEST_TASK_SCHEDULE_DELETE as any, requestTaskScheduleDelete);
}
